import React from 'react'
import EssLayout from '../../../../layout/components/ESSLayout'
import { useEffect, useState } from 'react';
import notificationServices from '../essNotificationServices';
import { useAppData } from '../../../../context/AppDataContext';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

function EssNotificationListPage() {



    const [notificationList, setNotificationList] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const { setUnreadCount } = useAppData();
    const navigate = useNavigate();

    const getList = (pageNumber) => {
        if (loading) return;

        setLoading(true);
        notificationServices.getList(pageNumber)
            .then(res => {
                const responseData = res.data; 
                
                setNotificationList(prev => {
                    const existingIds = new Set(prev.map(item => item.id));
                    const uniqueNewItems = responseData.data.filter(item => !existingIds.has(item.id));
                    return [...prev, ...uniqueNewItems];
                });
                
                if (responseData.current_page >= responseData.last_page) {
                    setHasMore(false);
                }
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
                setLoading(false);
            });
    };

    useEffect(() => {
        getList(1);
    }, []);

    const handleLoadMore = () => {
        if (!loading && hasMore) {
            const nextPage = page + 1;
            setPage(nextPage);
            getList(nextPage);
        }
    };

    const formatDate = (dateString) => {
        const notificationDate = moment(dateString);
        const sevenDaysAgo = moment().subtract(7, 'days');

        if (notificationDate.isAfter(sevenDaysAgo)) {
            return notificationDate.fromNow();
        } else {
            return notificationDate.format('MMMM D, YYYY, h:mm A');
        }
    };

    useEffect(() => {
        if (notificationList.length > 0) {
            notificationServices.markAllAsRead().then(res => {
                setUnreadCount(0);
            }).catch(() => {
            });
        }
    }, [notificationList]);


    const handleNotificationClick = (typeTag) => {
        let $link = "/";


        switch (typeTag.toLowerCase()) {
            case "task":
                $link = "/task";
                break;
            case "attendance":
                $link = "/team";
                break;
            case "project":
                $link = "/projects";
                break;
            case "work report":
                $link = "/work-report/team";
                break;
            case "leave request":
                //$link = "/my-team/leave-request";
                break;
            default:
                $link = "/";
        }

        navigate($link);
    }

    
    return (
        <EssLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h2>Notifications</h2>
                        <ul className="list-group">
                            {notificationList.map(notification => (
                                <li key={notification.id} className={`list-group-item ${notification.read_at ? '' : 'font-weight-bold'}`} onClick={() => handleNotificationClick(notification.type)}>
                                    
                                        <span className="fw-bold">{notification.title}</span>
                                        <div><span>{notification.body}</span></div>
                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                            <span className="badge bg-primary">{notification.type.toUpperCase()}</span>
                                            <small className="text-muted">{formatDate(notification.created_at)}</small>    
                                        </div>
                                        
                                    
                                </li>
                            ))}
                        </ul>
                        {hasMore && (
                            <div className="text-center mt-3">
                                <button className="btn btn-primary" onClick={handleLoadMore} disabled={loading}>
                                    {loading ? 'Loading...' : 'Load More'}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </EssLayout>
    )
}

export default EssNotificationListPage